import emoji from "emoji-dictionary"
import CodeFormatter from "../components/CodeFormatter"
import { fs } from "../controls/Constants"

const KariPulse = () => {

    const codeSnippet = 
`#include <kari.h>
using namespace kari;


void setup(){
    kariBegin({7,4,2});
}

void loop(){
    kariAsync::execute(
        [](){
            kariPulse({ {7, 4, 2}, "pulse1"});
        },
        1000
    );

}
`
    const introduction = 
    `The kariPulse class is a core component of the Kari IoT Library, designed to manage pulse states effectively in Arduino-based projects. 
    It provides a structured approach to handling and tracking pulse signals across multiple pins.\n
    This class ensures efficient pulse state tracking, making it ideal for real-time applications where accurate timing and state management are required.
    `
    return (
    <>
         <section>
            <h1>{emoji.getUnicode("repeat")} kariPulse</h1>
            <h2>Introduction</h2>
            <p className={`text-formatter ${fs}`}>{introduction}</p>
        </section>   
        <section>
                <h2>{emoji.getUnicode("wrench")} Key Features</h2>
                <ul className={`${fs}`}>
                    <li><strong>Pulse State Management </strong>- Track and manage pulse states with ease.</li>
                    <li><strong> Optimized for Performance</strong> - Designed for embedded and real-time applications.</li>
                </ul>
            </section>
            <h2>{emoji.getUnicode("hammer_and_wrench")} API Reference</h2>
            <CodeFormatter codeSnippet="void kariPulse(Pins array);" />
            <h3>Description:</h3>
                <ul className={`${fs}`}>
                    <li> <b className="fs-20">array</b> - is a special struct of type Pins.It takes in two parameters.</li>
                    <li>The first parameter is an array of integer pins and the second parameter is a unique string which works as an identifier.</li>
                    <li>The string must be unique for kariPulse to work correctly.
                    That means at no instance should more than one kariPulse use the same string as an identifier.
                    </li>
                    <li>{emoji.getUnicode("warning")}This should be taken with <strong>caution</strong> and 
                    ensure each kariPulse uses a unique string identifier. </li>
                </ul>
            <h2>{emoji.getUnicode("hammer")} Basic Usage Example</h2>
            <CodeFormatter codeSnippet={codeSnippet}/>

    </>
    )
}

export default KariPulse
